import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorPayload } from '../services/service';
import {
  BroadcastError,
  Campaign,
  ExcelAuditResult,
} from '../services/whatsappBroadcast.service';

// eslint-disable-next-line no-shadow
export enum ValidateExcelStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILURE = 'failure',
}

export type ValidateExcelState = {
  loading: ValidateExcelStatus;
  data?: ExcelAuditResult;
  error?: ErrorPayload | BroadcastError;
};

const initialState: ValidateExcelState = {
  loading: ValidateExcelStatus.IDLE,
  data: undefined,
  error: undefined,
};

export const validateExcelSlice = createSlice({
  name: 'validate-excel',
  initialState,
  reducers: {
    fetchValidateExcel(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _action: PayloadAction<Partial<Campaign> & { auditId?: string }>
    ) {
      // Trigger saga
    },
    fetchingValidateExcel(state) {
      state.loading = ValidateExcelStatus.PENDING;
      state.error = undefined;
    },
    fetchValidateExcelSuccess(state, action: PayloadAction<ExcelAuditResult>) {
      state.loading = ValidateExcelStatus.SUCCESS;
      state.data = action.payload;
      state.error = undefined;
    },
    fetchValidateExcelFailure(
      state,
      action: PayloadAction<ErrorPayload | BroadcastError>
    ) {
      state.loading = ValidateExcelStatus.FAILURE;
      state.data = undefined;
      state.error = action.payload;
    },
    clearValidateExcel(state) {
      state.loading = ValidateExcelStatus.IDLE;
      state.data = undefined;
      state.error = undefined;
    },
    clearValidateExcelError(state) {
      state.error = undefined;
    },
  },
});

export const {
  fetchValidateExcel,
  fetchingValidateExcel,
  fetchValidateExcelSuccess,
  fetchValidateExcelFailure,
  clearValidateExcel,
  clearValidateExcelError,
} = validateExcelSlice.actions;

export default validateExcelSlice.reducer;
